var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "property-base",
    { attrs: { label: _vm.label.text, forInput: _vm.label.for } },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.newValue,
            expression: "newValue"
          }
        ],
        staticClass: "form-control",
        attrs: { name: _vm.elementName, disabled: !_vm.canWrite, type: "text" },
        domProps: { value: _vm.newValue },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.newValue = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      !_vm.$v.newValue.required
        ? _c("required", { attrs: { fieldName: "Name" } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }